import { ByRoleMatcher, screen } from '@testing-library/preact';

//TODO: JET-63873
export function getIcon(menuItem: HTMLElement, selector: string) {
  return menuItem.querySelector(selector);
}

export function getAllMenuItemsByRole(role: ByRoleMatcher, hidden = true) {
  return screen.getAllByRole(role, { hidden });
}

export function getMenuItemByRole(role: ByRoleMatcher, hidden = true) {
  return screen.getByRole(role, { hidden });
}

export function getLabel(label: string) {
  return screen.getByText(label);
}

export function setObserverConfig() {
  if (!window.ResizeObserver) {
    // ResizeObserver isn't available in test environment
    const MockResizeObserver = jest.fn();
    MockResizeObserver.mockReturnValue({
      observe: () => null,
      unobserve: () => null,
      disconnect: () => null
    });

    Object.defineProperty(global, 'ResizeObserver', {
      writable: true,
      configurable: true,
      value: MockResizeObserver
    });
  }
}
